import { SortDirection, VFlow } from 'bold-ui'
import useSession from 'components/auth/useSession'
import { PageContent } from 'components/layout/PageContent'
import { useBuscaListagemHistoricoClinicoQuery } from 'graphql/hooks.generated'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import React, { Dispatch, Fragment, useEffect, useState } from 'react'
import { ExibirPorHistoricoAtendimentoFilterEnum } from 'types/enums'

import { AtendimentoFooter } from '../AtendimentoFooter'
import { convertToInput } from './components/filtro-historico/converter'
import HistoricoAtendimentoFilter from './components/filtro-historico/HistoricoAtendimentoFilter'
import HistoricoAtendimentoTable from './components/table/HistoricoAtendimentoTable'
import { HistoricoAtendimentoFilterFormModel } from './model/historicoFilterFormModel'
import { HistoricoAtendimentoListagemTableModel } from './model/historicoModel'

interface AtendimentoHistoricoViewProps {
  atendimentoId: ID
  cidadaoId: ID
  dataNascimentoCidadao: LocalDate
  cidadaoCpf: string
  cidadaoCns: string
  tipoAtendimentoProfissional?: TipoAtendimentoProfissional
  clearCache: Dispatch<void>
}

export function HistoricoAtendimentoView(props: AtendimentoHistoricoViewProps) {
  const { cidadaoId, clearCache, cidadaoCpf, cidadaoCns, dataNascimentoCidadao } = props

  const {
    data: {
      profissional: { cns },
    },
  } = useSession()

  const [sort, setSort] = useState<SortDirection>('')
  const [filtros, setFiltros] = useState<HistoricoAtendimentoFilterFormModel>({
    cidadaoId,
    profissionalCns: cns,
    cidadaoCpf,
    somenteMeusAtendimentos: false,
    periodoExibicao: ExibirPorHistoricoAtendimentoFilterEnum.TODOS_ATENDIMENTOS,
    pageParams: {
      size: 5,
    },
  })

  const { data, loading, refetch } = useBuscaListagemHistoricoClinicoQuery()

  useEffect(() => {
    refetch({
      input: convertToInput(filtros),
    })
  }, [filtros, refetch])

  const historico: HistoricoAtendimentoListagemTableModel = data?.historico

  return (
    <Fragment>
      <PageContent fluid type='filled'>
        <VFlow>
          <HistoricoAtendimentoFilter filtros={filtros} onChangeFiltros={setFiltros} />
          <HistoricoAtendimentoTable
            dataTable={historico}
            isLoading={loading}
            sort={sort}
            onSortChange={setSort}
            onChangeFilter={setFiltros}
            cpfOuCnsCidadao={cidadaoCpf ?? cidadaoCns}
            dataNascimentoCidadao={dataNascimentoCidadao}
          />
        </VFlow>
      </PageContent>
      <AtendimentoFooter
        atendimentoId={props.atendimentoId}
        tipoAtendimentoProfissional={props.tipoAtendimentoProfissional}
        clearCache={clearCache}
      />
    </Fragment>
  )
}
